import Vue from 'vue'
import Vuex from 'vuex'
import users from './modules/users';
import famille from './modules/famille';
import article from './modules/article';
import cart from './modules/cart';
import crossSellings from './modules/crossSellings';
import devis from './modules/devis';
import mode from './modules/mode'

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        users,
        famille,
        article,
        cart,
        crossSellings,
        devis,
        mode
    },
});